import { PageWrapper, Section } from '@everfi/reactifi';
import { Center } from '@chakra-ui/layout';
import { useHeapTracker } from '@lib/useHeapTracker';

const NextContentApp = () => {
  useHeapTracker();
  return (
    <PageWrapper>
      <Section>
        <Center>
          <h3>Welcome to Content Player Page</h3>
        </Center>
      </Section>
    </PageWrapper>
  );
};

export default NextContentApp;
